import React from "react";
import logoSrc from "../assets/images/logo.svg";
import { Link } from "react-router-dom";
import NewsletterSubscribe from "./NewsletterSubscribe";

const LinkedInIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
  </svg>
);

const XIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.616l-5.21-6.815-6.041 6.815h-3.308l7.682-8.756-8.349-10.75h6.766l4.634 6.257 5.49-6.257zm-1.4 17.52h2.16l-9.333-12.495h-2.298l9.471 12.495z" />
  </svg>
);

function Footer() {
  const linkedInUrl = "https://www.linkedin.com/company/zenithblox/";
  const xUrl = "https://x.com/zenithblox";
  const privacyPolicyPath = "/privacy-policy";
  const termsOfServicePath = "/terms-of-service";

  return (
    <footer className="bg-black text-gray-400 py-12 md:py-16 px-4 sm:px-6 lg:px-8">
      <div className="container mx-auto max-w-6xl mt-20 md:mt-28 lg:mt-32">
        {/* Top Section: Logo/Nav & Form */}
        <div className="flex flex-col lg:flex-row justify-between lg:items-start gap-10 lg:gap-8 mb-10">
          {/* Left Column: Logo, Description, Nav */}
          <div className="w-full lg:w-5/12">
            <div className="flex items-center mb-4">
              <Link to="/" className="flex items-center">
                <img className="h-10 w-auto" src={logoSrc} alt="ZenithBlox Logo" />
              </Link>
            </div>
            <p className="mb-6 text-sm leading-relaxed max-w-md">
              ZenithBlox powers the shift to blockchain—simplifying operations, boosting growth, and securing the future of finance.
            </p>
            {/* MODIFIED: Added flex-wrap and gap to handle wrapping on small screens */}
            <nav className="flex flex-wrap gap-x-6 gap-y-2 text-white font-medium text-sm">
              <Link to="/" className="hover:text-purple-400 transition-colors">
                Home
              </Link>
              <Link to="/about-us" className="hover:text-purple-400 transition-colors">
                About Us
              </Link>
              <Link to="/solutions" className="hover:text-purple-400 transition-colors">
                Solutions
              </Link>
              <Link to="/use-cases" className="hover:text-purple-400 transition-colors">
                Use Cases
              </Link>
            </nav>
          </div>

          {/* Right Column: Newsletter Subscription */}
          <div className="w-full lg:w-5/12">
            <NewsletterSubscribe className="w-full max-w-md" buttonText="Subscribe" darkMode={true} />
          </div>
        </div>

        {/* Separator Line */}
        <hr className="border-gray-700 my-8" />

        {/* Bottom Section: Copyright & Links */}
        <div className="flex flex-col items-center gap-4 md:flex-row md:justify-between text-xs text-gray-500 text-center md:text-left">
          <p>&copy; {new Date().getFullYear()} ZenithBlox. All rights reserved.</p>
          <div className="flex items-center space-x-4">
            <Link to={privacyPolicyPath} className="hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <Link to={termsOfServicePath} className="hover:text-white transition-colors">
              Terms of Service
            </Link>
            <a href={linkedInUrl} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" aria-label="LinkedIn">
              <LinkedInIcon />
            </a>
            <a href={xUrl} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" aria-label="X (formerly Twitter)">
              <XIcon />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
